import React from 'react'
import { Flex, Box, Text } from '@chakra-ui/react'
import { CheckIcon, Button } from '@blueprinthq/joy'

interface NoOverdueAssessmentsProps {
  onTakeAnyway: () => void
  children?: JSX.Element | null
}

export const NoOverdueAssessments = ({
  onTakeAnyway,
  children
}: NoOverdueAssessmentsProps) => {
  return (
    <Flex align="center" direction="column" paddingTop="small">
      <Flex
        bg="primary"
        width="64px"
        height="64px"
        borderRadius="50%"
        align="center"
        justify="center"
      >
        <CheckIcon size="lg" fill="white" />
      </Flex>
      <Box mt="large">
        <Text textAlign="center" fontWeight="bold" fontSize="lg">
          You're all set!
        </Text>
      </Box>
      <Box mt="xsmall" textAlign="center">
        <Text>
          You’ve completed your scheduled assessments and are on track! Feel free to retake them anytime or as requested by your clinician.
        </Text>
      </Box>
      <Box mt="medium" width="300px">
        <Button variant="outline" isFullWidth size="lg" onClick={onTakeAnyway}>
          Take assessment anyway
        </Button>
      </Box>
      {children}
    </Flex>
  )
}
